'use client';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { Schedules } from '@/components/pages/contacts/ContactsPage/Schedules/Schedules';
import { ActionButton } from '@/components/ui/ActionButton/ActionButton';
import CalendarSvg from '@/assets/icons/calendar.svg';
import { SchedulesData } from '@/components/pages/contacts/ContactsPage/Schedules/Schedules.types';
import s from './contactsHeader.module.scss';

const Modal = dynamic(() => import('@/components/layouts/Modal/Modal'), { ssr: false });

export const ContactsHeader = () => {
  const [schedules, setSchedules] = useState<SchedulesData>();
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <div className={s.contactsData}>
        <div className={s.contactsHeader}>
          <h1 className={s.title}>СтавРоссМед</h1>
          <p className={s.subtitle}>Клиника Передовой Медицины</p>
          <ActionButton
            onClick={() => setIsOpen(true)}
            className={s.calendar}
            isLine
          >
            <CalendarSvg />График работы
          </ActionButton>
        </div>
      </div>

      <Modal isOpen={isOpen} onClose={closeModal}>
        <Schedules schedules={schedules} setSchedules={setSchedules} />
      </Modal>
    </>
  );
};